import { render, staticRenderFns } from "./UnidadeMedidaAreaList.vue?vue&type=template&id=435cee4c&scoped=true"
import script from "./UnidadeMedidaAreaList.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaAreaList.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaAreaList.vue?vue&type=style&index=0&id=435cee4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435cee4c",
  null
  
)

export default component.exports